export const API_SERVICE_NAMES = {
  ACTIVITY: 'activity',
  ALLOCATIONS: 'allocations',
  AUTH: 'auth',
  FILE: 'file',
  PAYMENT: 'payment',
  PROPERTY: 'property',
  PAPER_CORRESPONDENCE: 'paperCorrespondence',
  AGGREGATE: 'aggregate',
  URJANET: 'urjanet',
  APPFOLIO: 'appfolio',
  ANONYMOUS: 'anonymous',
  STRIPE: 'stripe',
  BILL_AUTOMATION: 'billAutomation'
};